import React from "react"
import {
    Container,
    Col,
    Row,
    Badge
  } from 'reactstrap'
import Database from "./Database";
import votingtype from './images/votingtype.png'
import electronicvoting from './images/electronicvoting.png'
import universalsuffrage from './images/universalsuffrage.png'
import pastturnout from './images/pastturnout.png'

function CountryDetails(props){

    let mySelection=props.countryselected;

    //Filter your country
    const MyCountry = Database.filter(function(data){
        return(
            data.CountryName === mySelection
        )
    })

    let showhidestyles={
        display:"none",
    }

    if (mySelection !== "Select a country"){
        showhidestyles={
        display:"block",
        backgroundColor:"#eeeeee"
        }
    }

    let statusofvote1={
        display:"none"
    }
    let statusofvote2={
        display:"block"
    }

    if (MyCountry[0].VotingIn2019 === "NA"){
        statusofvote1={
            display:"block"
        }
        statusofvote2={
            display:"none"
        }

    }

    let mapflag="maps/"+MyCountry[0].CountryName+".svg"
    let seatsvg="seats/"+MyCountry[0].CountryName+".svg"
    let mapflagalt=MyCountry[0].CountryName+" map"
    let seatsvgalt=MyCountry[0].CountryName+" seats in parliament"

    return(
        <div>
        <Container style={statusofvote1}>
        <Row>
            <Col xs="12" md={{ size: 10, offset: 1 }} xl={{ size: 8, offset: 2 }} >
            <hr/>
            <h2 class="display-3 text-center">{MyCountry[0].CountryName}</h2>
            <br/>
            <h3>The leader of this country is not elected.</h3>
            </Col>
        </Row>
        <Row className="text-center">
                <Col className="individualbox">
                    <h2 className="orangetext">{MyCountry[0].CountryPopulation.toLocaleString('en')}</h2>
                    <p className="smalltext">POPULATION</p>
                </Col>
                <Col className="individualbox">
                    <h2 className="orangetext">{MyCountry[0].Area.toLocaleString('en')}</h2>
                    <p className="smalltext">AREA IN SQUARE KM</p>
                </Col>
        </Row>
        </Container>
        <Container style={statusofvote2}>
            <Row>
                <Col xs="12" md={{ size: 10, offset: 1 }} xl={{ size: 8, offset: 2 }} >
                <hr/>
                    <h2 class="display-3 text-center">{MyCountry[0].CountryName}</h2>
                    <br/>
                <Col/>
            <Row>
                <Col xs="12" md="4" className="text-center">
                    {/* <img width="80%" src={mapflag} alt={mapflagalt} /> */}
                </Col>
                <Col xs="12" md="4">
                <p className="smalltext">LEADER</p>
                <h3 className="presidentialterm">{MyCountry[0].LeaderType.toUpperCase()}</h3>
                </Col>
                <Col xs="12" md="4" className="text-center">
                    <p className="smalltext">ELECTED FOR:</p>
                    <h5 className="presidentialterm"><span style={{display: MyCountry[0].LeadershipTerm===1000 ? "inline-block":"none"}}>No fixed duration</span><span style={{display: MyCountry[0].LeadershipTerm===1000 ? "none":"inline-block"}}>{MyCountry[0].LeadershipTerm} years</span></h5>
                    <p className="smalltext">MAXIMUM TERMS:</p>
                    <h5 className="presidentialterm"><span style={{display: MyCountry[0].MaximumTerms===1000 ? "inline-block":"none"}}>No limit</span><span style={{display: MyCountry[0].MaximumTerms===1000 ? "none":"inline-block"}}>{MyCountry[0].MaximumTerms}</span></h5>
                </Col>
            </Row>
            <Row className="text-center">
                <Col sm={{ size: 8, offset: 2 }} xs={{ size: 10, offset: 1 }}>
                    <img width="100%" src={seatsvg} alt={seatsvgalt} />
                    <h2>SEATS IN PARLIAMENT</h2>
                </Col>
            </Row>
            <Row className="text-center">
                <Col className="individualbox">
                    <h2 className="orangetext">{MyCountry[0].CountryPopulation.toLocaleString('en')}</h2>
                    <p className="smalltext">POPULATION</p>
                </Col>
                <Col className="individualbox">
                <h2 style={{color:"#281804"}} className="orangetext">{MyCountry[0].NextElectionDate}</h2>
                    <p className="smalltext">ELECTION DATE</p>
                </Col>
                <Col className="individualbox">
                    <h2 className="orangetext">{MyCountry[0].Area.toLocaleString('en')}</h2>
                    <p className="smalltext">AREA IN SQUARE KM</p>
                </Col>
            </Row>
            <Row className="text-center">
                <Col className="individualbox">
                    <h2 className="orangetext">{MyCountry[0].VotingAge}</h2>
                    <p className="smalltext">VOTING AGE</p>
                </Col>
                <Col className="individualbox">
                    <h2 className="orangetext">{MyCountry[0].ElectionType}</h2>
                    <p className="smalltext">ELECTION TYPE <a href="#electiontype"><Badge className="tipbadge" color="secondary">?</Badge></a></p>
                </Col>
            </Row>
            <Row className="text-center">
                <Col className="individualbox">
                    <h2 className="orangetext">{MyCountry[0].VotingType}</h2>
                    <img width="100%" src={votingtype} alt="voting type"/>
                    <p className="smalltext">VOTING TYPE <a href="#votingtype"><Badge className="tipbadge" color="secondary">?</Badge></a></p>
                </Col>
                <Col className="individualbox">
                    <h2 className="orangetext">{MyCountry[0].ElectronicVoting}</h2>
                    <img width="100%" src={electronicvoting} alt="voting type"/>
                    <p className="smalltext">ELECTRONIC VOTING</p>
                    {/* <p className="smalltext">ELECTRONIC VOTING <a href="#electronicvoting"><Badge className="tipbadge" color="secondary">?</Badge></a></p> */}
                </Col>
            </Row>
            <Row className="text-center">
                <Col className="individualbox">
                    <h2 className="orangetext">{MyCountry[0].WhenWomenCouldVote}</h2>
                    <img width="100%" src={universalsuffrage} alt="voting type"/>
                    <p className="smalltext">UNIVERSAL SUFFRAGE <a href="#suffrage"><Badge className="tipbadge" color="secondary">?</Badge></a></p>
                </Col>
                <Col className="individualbox">
                    <h2 className="orangetext">{MyCountry[0].PastElectionTurnout}</h2>
                    <img width="100%" src={pastturnout} alt="voting type"/>
                    <p className="smalltext">PREVIOUS ELECTION TURNOUT</p>
                </Col>
            </Row>
            </Col>
            </Row>
        </Container>
        </div>
    )
}
export default CountryDetails